import React from 'react';
import styled from '@emotion/styled';
import PolarisIcon from '@/components/_common/PolarisIcon';

interface FolderIconProps {
  open?: boolean;
  hover?: boolean;
}

const FolderIcon: React.FC<FolderIconProps> = ({ open = false, hover = false }) => {
  return <FolderIconWrapper icon={open || hover ? 'folder_open' : 'folder'} open={open} />;
};

export default FolderIcon;

const FolderIconWrapper = styled(PolarisIcon)<{ open: boolean }>`
  font-size: 22px;
  ${({ open, theme }) =>
    open &&
    `
    color: ${theme.palette.primary.main};
  `}
`;
